import { Grid, Stack } from '@mui/material';

import { useDrawerFilter } from '@hapvida/hapvida-core-components';

import { useAuth, useFilterParams } from '@hooks';
import { SubHeader } from '@components';
import { UserType } from '@contexts';
import { NewFilterDrawerCompanySetup } from 'components/filters/NewFiltersParams/NewFilterDrawerCompanySetup';
import NewSearchField from 'components/filters/NewFiltersParams/NewSearchField';

import { useCompanySetupListMobileState } from '../../hooks/useCompanySetupListMobileState';

export function CompanySetupListSubHeaderMobile() {
  const { hasFilters } = useFilterParams();
  const { filterCount } = useDrawerFilter();
  const { companySetupListMobileState } = useCompanySetupListMobileState();
  const { user } = useAuth();

  const { data: dataMobile, isError, isLoading } = companySetupListMobileState;

  const isBackoffice = user?.companyType === UserType.Backoffice;

  const totalCompanySetupListLength = dataMobile?.pages[0].total ?? 0;

  const isResultEmpty = totalCompanySetupListLength === 0;

  const isEmpty = isResultEmpty && !hasFilters;

  const disableButtonSearch = isLoading && hasFilters;

  const filtersDrawerButtonDisabled =
    !filterCount && (isLoading || isResultEmpty);

  if ((!hasFilters && isLoading) || isError || isEmpty) {
    return null;
  }

  return (
    <SubHeader>
      <Grid container spacing={3}>
        <Grid item display={'flex'} gap={'16px'} width={'100%'}>
          <Stack flexGrow={1}>
            <NewSearchField
              name="search"
              currentResultLength={totalCompanySetupListLength}
              placeholder="Buscar nome da matriz ou CNPJ"
              disableSearch={disableButtonSearch}
            />
          </Stack>
          {isBackoffice && (
            <NewFilterDrawerCompanySetup
              subtitle="Selecione como deseja filtrar as empresas"
              title="Filtrar empresas"
              disabled={filtersDrawerButtonDisabled}
              style={{ width: 'fit-content' }}
            />
          )}
        </Grid>
      </Grid>
    </SubHeader>
  );
}
